import type { IntlConfig } from "$src/core/models/intl";
import getDeviceTimeZone from "$src/core/utils/date/get-device-time-zone";

/** App-wide calendar timezone: fixed from flavor config, or device local. */
const getAppTimeZone = (intl: IntlConfig): string => {
  if (intl.timeZone.type === "fixed") {
    return intl.timeZone.value;
  }

  return getDeviceTimeZone();
};

export default getAppTimeZone;
